import { Injectable } from '@angular/core';
import { appendDateToString } from '@boma/shared/common';
import * as FileSaver from 'file-saver';

@Injectable({
  providedIn: 'root',
})
export class ExportDocumentService {
  locationsHeader;

  updateDocumentTitle(title, locationHeader) {
    const d = new Date();
    // TODO Improve this by changing the parameters to an object
    if (typeof locationHeader === 'object') {
      document.title = appendDateToString({
        title: title,
        locations: locationHeader,
      });
    } else {
      document.title = appendDateToString({
        title: title,
        location: locationHeader,
      });
    }
  }

  exportExcelFromHtml(html) {
    import('xlsx').then((xlsx) => {
      //Lets calculate column widths
      const columnWidths = [];
      const alpha = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
      const workbook = xlsx.read(html, { type: 'string' });
      for (let [key, value] of Object.entries(workbook['Sheets'])) {
        const worksheet = value;
        for (const [key2, value2] of Object.entries(value)) {
          // column row a1b1c1d1e1...
          if (value2?.v) {
            const tempLength = value2.v.toString().length;
            const currentColumn = alpha.indexOf(key2.substring(0, 1)); // this wont work for double alpha values
            columnWidths[currentColumn] =
              columnWidths[currentColumn] > tempLength
                ? columnWidths[currentColumn]
                : tempLength;
          }
        }
        const widest = [];
        columnWidths.map((x) => widest.push({ wch: x }));
        worksheet['!cols'] = widest;
      }
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
      });

      const documentTitle = document.title;

      this.saveAsExcelFile(excelBuffer, documentTitle);
    });
  }

  exportExcel(data, locationHeader, sheetNames = ['data']) {
    // this.exportExcelFromHtml(
    //   document.getElementById('print-content').innerHTML
    // );

    //todo headings
    //todo column widths
    console.log(data);
    this.locationsHeader = locationHeader;

    import('xlsx').then((xlsx) => {
      const workbook = xlsx.utils.book_new();
      const worksheet = xlsx.utils.json_to_sheet(data);
      xlsx.utils.book_append_sheet(workbook, worksheet, sheetNames[0]);
      //loop through all entries to establish the longest values to ensure correct column width in excel... should probably build in a max value.
      let widestWidth = [];
      data.map((x) => {
        console.log(x);
        const row = [];
        for (const key in x) {
          if (key) {
            const val_one = key?.length;
            const val_two = x[key]?.length || 0;
            const bigLength = val_one > val_two ? val_one : val_two;
            row.push(bigLength);
          }
        }
        if (!widestWidth[0]) {
          widestWidth = row;
        } else {
          widestWidth.map((w, index) => {
            if (w > row[index]) {
              widestWidth[index] = w;
            } else {
              widestWidth[index] = row[index];
            }
          });
        }
      });

      const columnWidths = [];

      widestWidth.map((x) => columnWidths.push({ wch: x }));

      worksheet['!cols'] = columnWidths;

      const excelBuffer: any = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
      });

      this.saveAsExcelFile(excelBuffer, this.locationsHeader);
    });
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE =
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(
      data,
      fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION
    );
  }

  saveAsCSV(data, locationHeader) {
    const exportFlatData = data;
    this.locationsHeader = locationHeader;
    //Create a flat array so the reports dont get stupid.
    let csv = '';
    const csvSeparator = ';';
    const csvHeaders = new Map();

    exportFlatData.forEach((record, i) => {
      //console.log(record);
      for (const key in record) {
        const csvHeader = '"' + key + '"';
        if (!csvHeaders.has(key)) {
          csvHeaders.set(key, csvHeader);
        }
        csv += '"' + record[key] + '"';
        //console.log(`${key}: ${record[key]}`);
      }
      if (i < exportFlatData.length - 1) {
        csv += csvSeparator;
      }
      csv += '\n';
    });
    csv = Array.from(csvHeaders.values()).join(csvSeparator) + '\n' + csv;
    const blob = new Blob([csv], {
      type: 'text/csv;charset=utf-8;',
    });
    if ((window.navigator as any).msSaveOrOpenBlob) {
      (navigator as any).msSaveOrOpenBlob(blob, document.title + '.csv');
    } else {
      const link = document.createElement('a');
      link.style.display = 'none';
      document.body.appendChild(link);
      if (link.download !== undefined) {
        link.setAttribute('href', URL.createObjectURL(blob));
        link.setAttribute('download', document.title + '.csv');
        link.click();
      } else {
        csv = 'data:text/csv;charset=utf-8,' + csv;
        window.open(encodeURI(csv));
      }
      document.body.removeChild(link);
    }
  }
}
